import { message } from 'antd';
import dayjs from 'dayjs';

const useStepFormLogic = () => {
  // 内容验证逻辑
  const validateStepContent = (values, inputBoxes, momentBoxes, mediaState) => {
    let hasContentError = false;
    let errorMessage = '';

    // 验证消息内容
    if (values.type === 'MESSAGE') {
      const textBox = inputBoxes.find(box => box.type === 'TEXT');
      const mediaBox = inputBoxes.find(box => box.type !== 'TEXT');
      
      const hasText = textBox && textBox.content && textBox.content.trim() !== '';
      
      let hasMedia = false;
      if (mediaBox) {
        if (mediaBox.type === 'IMAGE_GROUP') {
          const imageGroup = mediaState.messageImageGroupIds[mediaBox.id];
          hasMedia = imageGroup && imageGroup.mediaIds && imageGroup.mediaIds.length > 0;
        } else if (mediaBox.type === 'VIDEO') {
          const mediaId = mediaState.messageVideoIds[mediaBox.id] || mediaState.messageMediaIds[mediaBox.id] || mediaBox.videoMediaId || mediaBox.mediaId || '';
          hasMedia = mediaId && mediaId.trim() !== '';
        } else if (mediaBox.type === 'LINK') {
          hasMedia = mediaBox.url && mediaBox.url.trim() !== '' && mediaBox.title && mediaBox.title.trim() !== '';
        } else if (mediaBox.type === 'MINIPROGRAM') {
          hasMedia = mediaBox.appid && mediaBox.appid.trim() !== '' &&
            mediaBox.title && mediaBox.title.trim() !== '' &&
            mediaBox.pagepath && mediaBox.pagepath.trim() !== '' &&
            (mediaBox.thumbMediaId && mediaBox.thumbMediaId.trim() !== '');
        }
      }
      
      if (!hasText && !hasMedia) {
        hasContentError = true;
        errorMessage = '请至少添加文本内容或多媒体内容';
      }
    }
    // 验证朋友圈内容
    else if (values.type === 'MOMENTS') {
      const textBox = momentBoxes.find(box => box.type === 'MOMENT_TEXT');
      const mediaBox = momentBoxes.find(box => box.type !== 'MOMENT_TEXT');
      
      const hasText = textBox && textBox.content && textBox.content.trim() !== '';
      
      let hasMedia = false;
      if (mediaBox) {
        if (mediaBox.type === 'MOMENT_IMAGE_GROUP') {
          const imageGroup = mediaState.momentImageGroupIds[mediaBox.id];
          hasMedia = imageGroup && imageGroup.mediaIds && imageGroup.mediaIds.length > 0;
        } else if (mediaBox.type === 'MOMENT_VIDEO') {
          const mediaId = mediaState.momentVideoIds[mediaBox.id] || mediaState.momentMediaIds[mediaBox.id] || mediaBox.mediaId || '';
          hasMedia = mediaId && mediaId.trim() !== '';
        } else if (mediaBox.type === 'MOMENT_LINK') {
          hasMedia = mediaBox.url && mediaBox.url.trim() !== '' && mediaBox.title && mediaBox.title.trim() !== '';
        }
      }
      
      if (!hasText && !hasMedia) {
        hasContentError = true;
        errorMessage = '请至少添加文本内容或多媒体内容';
      }
    }

    return { hasContentError, errorMessage };
  };

  // 构建消息列表
  const buildMessageList = (inputBoxes, values, mediaState) => {
    return inputBoxes
      .map(box => {
        const messageItem = {
          id: box.id,
          type: box.type,
          params: {}
        };

        switch (box.type) {
          case 'TEXT':
            messageItem.params = {
              content: values.actionParams?.content || box.content || ''
            };
            break;
          case 'IMAGE':
            const imageMediaId = mediaState.messageImageIds[box.id] || mediaState.messageMediaIds[box.id] || box.mediaId || '';
            messageItem.params = {
              mediaId: imageMediaId,
              ossUrl: mediaState.messageOssUrls?.[box.id] || box.mediaId_ossUrl || ''
            };
            break;
          case 'IMAGE_GROUP':
            const imageGroup = mediaState.messageImageGroupIds[box.id] || { mediaIds: [], ossUrls: {} };
            messageItem.params = {
              imageGroup: imageGroup
            };
            break;
          case 'VIDEO':
            const videoMediaId = mediaState.messageVideoIds[box.id] || mediaState.messageMediaIds[box.id] || box.videoMediaId || box.mediaId || '';
            const videoOssUrl = mediaState.messageOssUrls?.[box.id] || box.ossUrl || box.videoMediaId_ossUrl || box.mediaId_ossUrl || '';
            console.log("构建视频消息:", {
              boxId: box.id,
              videoMediaId,
              videoOssUrl,
              mediaState: mediaState.messageVideoIds,
              step: 'buildMessageList'
            });
            messageItem.params = {
              mediaId: videoMediaId,
              ossUrl: videoOssUrl
            };
            break;
          case 'FILE':
            const fileMediaId = mediaState.messageFileIds[box.id] || mediaState.messageMediaIds[box.id] || box.fileMediaId || box.mediaId || '';
            messageItem.params = {
              mediaId: fileMediaId,
              ossUrl: mediaState.messageOssUrls?.[box.id] || box.fileMediaId_ossUrl || box.mediaId_ossUrl || ''
            };
            break;
          case 'LINK':
            messageItem.params = {
              title: values.actionParams?.title || box.title || '',
              description: values.actionParams?.description || box.description || '',
              url: values.actionParams?.url || box.url || '',
              picUrl: values.actionParams?.picUrl || box.picUrl || '',
              picUrl_ossUrl: mediaState.messageOssUrls?.[box.id] || box.picUrl_ossUrl || ''
            };
            break;
          case 'MINIPROGRAM':
            messageItem.params = {
              title: values.actionParams?.title || box.title || '',
              appid: values.actionParams?.appid || box.appid || '',
              pagepath: values.actionParams?.pagepath || box.pagepath || '',
              thumbMediaId: values.actionParams?.thumbMediaId || box.thumbMediaId || '',
              thumbMediaId_ossUrl: mediaState.messageOssUrls?.[box.id] || box.thumbMediaId_ossUrl || ''
            };
            break;
        }

        return messageItem;
      })
      .filter(msg => {
        if (msg.type === 'TEXT') {
          return msg.params.content && msg.params.content.trim() !== '';
        }
        if (['IMAGE', 'VIDEO', 'FILE'].includes(msg.type)) {
          return msg.params.mediaId && msg.params.mediaId.trim() !== '';
        }
        if (msg.type === 'IMAGE_GROUP') {
          return msg.params.imageGroup && 
                 msg.params.imageGroup.mediaIds && 
                 msg.params.imageGroup.mediaIds.length > 0;
        }
        if (msg.type === 'LINK') {
          return msg.params.url && msg.params.url.trim() !== '';
        }
        if (msg.type === 'MINIPROGRAM') {
          return msg.params.appid && msg.params.appid.trim() !== '';
        }
        return false;
      });
  };

  // 构建朋友圈列表
  const buildMomentsList = (momentBoxes, mediaState) => {
    return momentBoxes
      .map(box => {
        const momentItem = {
          id: box.id,
          type: box.type,
          params: {}
        };

        switch (box.type) {
          case 'MOMENT_TEXT':
            momentItem.params = {
              content: box.content || ''
            };
            break;
          case 'MOMENT_IMAGE':
            const imageMediaId = mediaState.momentImageIds[box.id] || mediaState.momentMediaIds[box.id] || box.mediaId || '';
            momentItem.params = {
              mediaId: imageMediaId,
              ossUrl: mediaState.momentOssUrls?.[box.id] || box.mediaId_ossUrl || ''
            };
            break;
          case 'MOMENT_IMAGE_GROUP':
            const imageGroup = mediaState.momentImageGroupIds[box.id] || { mediaIds: [], ossUrls: {} };
            momentItem.params = {
              imageGroup: imageGroup
            };
            break;
          case 'MOMENT_VIDEO':
            const videoMediaId = mediaState.momentVideoIds[box.id] || mediaState.momentMediaIds[box.id] || box.mediaId || '';
            momentItem.params = {
              mediaId: videoMediaId,
              ossUrl: mediaState.momentOssUrls?.[box.id] || box.mediaId_ossUrl || ''
            };
            break;
          case 'MOMENT_LINK':
            momentItem.params = {
              title: box.title || '',
              description: box.description || '',
              url: box.url || '',
              picUrl: box.picUrl || '',
              picOssUrl: mediaState.momentOssUrls?.[box.id] || box.picUrl_ossUrl || ''
            };
            break;
        }

        return momentItem;
      })
      .filter(item => {
        if (item.type === 'MOMENT_TEXT') {
          return item.params.content && item.params.content.trim() !== '';
        }
        if (['MOMENT_IMAGE', 'MOMENT_VIDEO'].includes(item.type)) {
          return item.params.mediaId && item.params.mediaId.trim() !== '';
        }
        if (item.type === 'MOMENT_IMAGE_GROUP') {
          return item.params.imageGroup && 
                 item.params.imageGroup.mediaIds && 
                 item.params.imageGroup.mediaIds.length > 0;
        }
        if (item.type === 'MOMENT_LINK') {
          return item.params.url && item.params.url.trim() !== '';
        }
        return false;
      });
  };

  // 展开图片集为单独的图片消息
  const expandImageGroups = (messageList, isMoments = false) => {
    const expandedList = [];
    
    messageList.forEach(msg => {
      const isImageGroup = isMoments ? 
        (msg.type === 'MOMENT_IMAGE_GROUP' && msg.params.imageGroup) :
        (msg.type === 'IMAGE_GROUP' && msg.params.imageGroup);
        
      if (isImageGroup) {
        const { mediaIds, ossUrls } = msg.params.imageGroup;
        const imageType = isMoments ? 'MOMENT_IMAGE' : 'IMAGE';
        
        mediaIds.forEach((mediaId, index) => {
          expandedList.push({
            id: `${msg.id}-img-${index}`,
            type: imageType,
            params: {
              mediaId: mediaId,
              ossUrl: ossUrls[mediaId] || ''
            }
          });
        });
      } else {
        expandedList.push(msg);
      }
    });
    
    return expandedList;
  };

  // 构建actionParams
  const buildActionParams = (messageList, momentsList, stepType) => {
    if (stepType === 'MESSAGE') {
      const actionParams = {
        subtype: 'MESSAGE',
        text: '',
        attachments: []
      };

      messageList.forEach(msg => {
        if (msg.type === 'TEXT') {
          actionParams.text = msg.params.content || '';
        } else if (msg.type === 'IMAGE') {
          console.log('buildActionParams - 处理IMAGE:', msg.params);
          actionParams.attachments.push({
            msgtype: 'image',
            image: {
              media_id: msg.params.mediaId || '',
              oss_url: msg.params.ossUrl || ''
            }
          });
        } else if (msg.type === 'VIDEO') {
          console.log("构建视频附件:", {
            mediaId: msg.params.mediaId,
            ossUrl: msg.params.ossUrl,
            step: 'buildActionParams'
          });
          actionParams.attachments.push({
            msgtype: 'video',
            video: {
              media_id: msg.params.mediaId || '',
              oss_url: msg.params.ossUrl || ''
            }
          });
        } else if (msg.type === 'FILE') {
          actionParams.attachments.push({
            msgtype: 'file',
            file: {
              media_id: msg.params.mediaId || '',
              oss_url: msg.params.ossUrl || ''
            }
          });
        } else if (msg.type === 'LINK') {
          actionParams.attachments.push({
            msgtype: 'link',
            link: {
              title: msg.params.title || '',
              url: msg.params.url || '',
              desc: msg.params.description || '',
              picurl: msg.params.picUrl || '',
              pic_oss_url: msg.params.picUrl_ossUrl || ''
            }
          });
        } else if (msg.type === 'MINIPROGRAM') {
          actionParams.attachments.push({
            msgtype: 'miniprogram',
            miniprogram: {
              title: msg.params.title || '',
              appid: msg.params.appid || '',
              page: msg.params.pagepath || '',
              pic_media_id: msg.params.thumbMediaId || '',
              pic_oss_url: msg.params.thumbMediaId_ossUrl || ''
            }
          });
        }
      });

      return actionParams;
    } else if (stepType === 'MOMENTS') {
      const actionParams = {
        subtype: 'MOMENTS',
        text: { content: '' },
        attachments: []
      };

      momentsList.forEach(item => {
        if (item.type === 'MOMENT_TEXT') {
          actionParams.text.content = item.params.content || '';
        } else if (item.type === 'MOMENT_IMAGE') {
          actionParams.attachments.push({
            msgtype: 'image',
            image: {
              media_id: item.params.mediaId || '',
              oss_url: item.params.ossUrl || ''
            }
          });
        } else if (item.type === 'MOMENT_VIDEO') {
          actionParams.attachments.push({
            msgtype: 'video',
            video: {
              media_id: item.params.mediaId || '',
              oss_url: item.params.ossUrl || ''
            }
          });
        } else if (item.type === 'MOMENT_LINK') {
          actionParams.attachments.push({
            msgtype: 'link',
            link: {
              title: item.params.title || '',
              desc: item.params.description || '',
              url: item.params.url || '',
              picurl: item.params.picUrl || '',
              pic_oss_url: item.params.picOssUrl || ''
            }
          });
        }
      });

      return actionParams;
    }

    return {};
  };

  // 主要的保存逻辑
  const buildStepData = (values, currentStep, inputBoxes, momentBoxes, mediaState, isScheduled) => {
    console.log("保存步骤 - 表单值:", values);
    console.log("当前输入框:", inputBoxes);
    console.log("当前朋友圈框:", momentBoxes);

    // 确保所有URL都是以http(s)://开头的
    if (values.type === 'MESSAGE') {
      const boxWithLink = inputBoxes.find(box => box.type === 'LINK');
      if (boxWithLink && boxWithLink.url) {
        if (!/^https?:\/\//i.test(boxWithLink.url)) {
          boxWithLink.url = `https://${boxWithLink.url}`;
        }
      }
    } else if (values.type === 'MOMENTS') {
      const boxWithLink = momentBoxes.find(box => box.type === 'MOMENT_LINK');
      if (boxWithLink && boxWithLink.url) {
        if (!/^https?:\/\//i.test(boxWithLink.url)) {
          boxWithLink.url = `https://${boxWithLink.url}`;
        }
      }
    }

    // 验证内容
    const { hasContentError, errorMessage } = validateStepContent(values, inputBoxes, momentBoxes, mediaState);
    if (hasContentError) {
      message.error(errorMessage);
      return null;
    }

    // 构建基本步骤数据
    const stepData = {
      name: values.name,
      description: values.description || '',
      stepCode: values.stepCode,
      type: values.type,
      actionType: values.actionType,
      actionParams: {}
    };

    // 如果是编辑现有步骤，保留原ID
    if (currentStep && currentStep.id) {
      stepData.id = currentStep.id;
    }

    // 确保根据步骤类型设置正确的actionType
    if (stepData.type === 'MESSAGE') {
      stepData.actionType = 'SEND_MESSAGE';
    } else if (stepData.type === 'MOMENTS') {
      stepData.actionType = 'SEND_MOMENT';
    } else if (stepData.type === 'TAG') {
      stepData.actionType = values.actionType || 'UPDATE_TAG';
    } else if (!stepData.actionType) {
      stepData.actionType = 'DEFAULT_ACTION';
      console.warn('未知的步骤类型，设置默认actionType:', stepData.type);
    }

    // 处理定时SOP的步骤级别设置
    if (isScheduled) {
      if (values.scheduledDateTime && dayjs.isDayjs(values.scheduledDateTime)) {
        stepData.scheduledDate = values.scheduledDateTime.format('YYYY-MM-DD');
        stepData.scheduledTime = values.scheduledDateTime.format('HH:mm:ss');
      }

      if (values.stepTargetType) {
        const targetRules = [];

        if (values.stepTargetType === 'ALL') {
          targetRules.push({
            targetType: 'ALL',
            targetIds: []
          });
        } else if ((values.stepTargetType === 'TAG' || values.stepTargetType === 'GROUP') &&
          values.stepTargetIds && values.stepTargetIds.length > 0) {
          targetRules.push({
            targetType: values.stepTargetType,
            targetIds: values.stepTargetIds.map(id => String(id))
          });
        }

        if (targetRules.length > 0) {
          stepData.targetRules = targetRules;
          console.log("设置步骤级别目标规则:", stepData.targetRules);
        }
      }

      if (values.stepEmployeeIds && values.stepEmployeeIds.length > 0) {
        stepData.employeeIds = values.stepEmployeeIds.map(id => String(id));
        console.log("设置步骤级别执行人:", stepData.employeeIds);
      }
    } else {
      stepData.timeOffsetDays = values.timeOffsetDays || 0;
      stepData.executeTime = values.executeTime && dayjs.isDayjs(values.executeTime) ?
        values.executeTime.format('HH:mm:ss') : values.executeTime;
    }

    // 根据步骤类型构建具体数据
    if (values.type === 'MESSAGE') {
      stepData.messageList = buildMessageList(inputBoxes, values, mediaState);
      console.log('MESSAGE - buildMessageList结果:', stepData.messageList);
      
      stepData.messageList = expandImageGroups(stepData.messageList, false);
      console.log('MESSAGE - expandImageGroups后:', stepData.messageList);
      
      stepData.actionParams = buildActionParams(stepData.messageList, [], 'MESSAGE');
    } else if (values.type === 'TAG') {
      stepData.actionParams = {
        tagId: values.actionParams?.tagId,
        operation: values.actionType === 'ADD_TAG' ? 'ADD' : 'REMOVE'
      };
    } else if (values.type === 'MOMENTS') {
      stepData.momentsList = buildMomentsList(momentBoxes, mediaState);
      console.log('MOMENTS - buildMomentsList结果:', stepData.momentsList);
      
      stepData.momentsList = expandImageGroups(stepData.momentsList, true);
      console.log('MOMENTS - expandImageGroups后:', stepData.momentsList);
      
      stepData.actionParams = buildActionParams([], stepData.momentsList, 'MOMENTS');
    }

    console.log("最终保存的步骤数据:", stepData);
    return stepData;
  };

  return {
    buildStepData
  };
};

export default useStepFormLogic; 